import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { routeCodes } from "../../config/routes";
import { getString, sortedArrayByItem } from "../../utilities";
import grades from "../../config/grades";

export default function OurContent() {
  const gamesTitle = getString("games.all.0").toUpperCase();

  const sortedGrades = useMemo(() => {
    return sortedArrayByItem(grades, "number");
  }, []);

  const renderLinks = () => {
    if (sortedGrades) {
      return sortedGrades.map((grade, index) => {
        const myString = index === 0 ? "footer.games.0" : "footer.games.1";

        return (
          <Link to={`${routeCodes.GRADES}${grade.url}`} key={grade.url}>
            {getString(myString, { replace: [grade.shortname] })}
          </Link>
        );
      });
    }
    return null;
  };

  return (
    <div className="footer-nav-col">
      <div className="title">
        <span>{getString("footer.content")}</span>
      </div>
      <Link to={routeCodes.GAMES}>{gamesTitle}</Link>
      {renderLinks()}
      <Link to={routeCodes.PRINTABLES}>{getString("printables.title.0")}</Link>
    </div>
  );
}
